import {
  copyrightFontSize,
  disclaimerFontSize,
  emailDefaultBackgroundColour,
  emailDefaultTextColour,
  emailFontFamily,
  tableWidth,
} from '../pro-report-email-styles';

function ProReportEmailFooter() {
  const copyrightYear = new Date().getFullYear();
  return (
    <table width={tableWidth} role="presentation">
      <tr>
        <td
          style={{
            margin: 0,
            backgroundColor: emailDefaultBackgroundColour,
            color: emailDefaultTextColour,
            fontFamily: emailFontFamily,
            fontSize: disclaimerFontSize,
            width: tableWidth,
          }}
        >
          The purpose of this report is to provide a source of information which
          is additional to that available to the maritime industry from
          regulatory, advisory, and consultative organisations. Whilst care is
          taken to ensure the accuracy of any information made available no
          warranty of accuracy is given and users of that information are to be
          responsible for satisfying themselves that the information is relevant
          and suitable for the purposes to which it is applied. In no
          circumstances whatsoever shall NorthStandard be liable to any person
          whatsoever for any loss or damage whensoever or howsoever arising out
          of or in connection with the supply (including negligent supply) or
          use of information. Unless the contrary is indicated, all articles are
          written with reference to English Law. However it should be noted that
          the content of this report does not constitute legal advice and should
          not be construed as such. Members should contact NorthStandard for
          specific advice on particular matters.
        </td>
      </tr>
      <tr>
        <td
          style={{
            margin: 0,
            backgroundColor: emailDefaultBackgroundColour,
            color: emailDefaultTextColour,
            fontFamily: emailFontFamily,
            fontSize: copyrightFontSize,
            width: tableWidth,
          }}
        >
          <b>© {copyrightYear} NorthStandard Limited. All rights reserved.</b>
        </td>
      </tr>
    </table>
  );
}

export default ProReportEmailFooter;
